import { Injectable } from '@angular/core';
import { Product } from '../classes/product';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ItProductsService } from '../services/it-products.service';
import { Observable } from 'rxjs';

@Injectable()
export class ItProductsResolve {
  constructor(private itProductsService: ItProductsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Product[]> | Promise<Product[]> | Product[] {
    return this.itProductsService.getProducts();
  }
}
